import { axiosInstance } from '@/utils/api'
import { IWarehouse } from '@/utils/types/model/warehouse'

interface IWarehouseListResponse {
  totalRecords: number
  warehouseMasters: IWarehouse[]
}

export async function getWarehouses(
  page: number,
  limit: number,
  code?: string,
  sortBy?: string,
  sortType?: string
): Promise<IWarehouseListResponse> {
  const params: Record<string, unknown> = {
    page,
    limit,
  }

  if (code) {
    params.code = code
  }

  if (sortBy) {
    params.sortBy = sortBy
  }

  if (sortType) {
    params.sortType = sortType
  }

  const response = await axiosInstance.get('/warehouses', { params })
  return response.data
}

export async function exportWarehouses(data: { sortBy?: string; sortType?: string }) {
  const response = await axiosInstance.post('/warehouses/export', data)
  return response.data
}
